// Глобальные константы

export const define = {
    host: '',
    pathToGraphics: '', //путь к графическим элементам
    pathToAPI: '', // путь к API
}

if(window.location.hostname === 'localhost'){
// if(location.hostname === 'localhost'){
    define.host = 'http://localhost:8080'
    define.pathToAPI =  'https://api-catalog'// Путь к API
    define.pathToGraphics = 'https://api-catalog/libs/_graphics(copy)'
} else {
    define.host = 'https://massaclub.com'
    define.pathToAPI =  'https://massaclub.com/api-catalog'
    define.pathToGraphics = 'https://massaclub.com/api-catalog/libs/_graphics(copy)'
}

define.pathToUploads = define.pathToAPI + '/multiupload/uploads'
define.prevFolder = define.pathToUploads + '/190px/'
define.prevFolder2 = define.pathToUploads + '/40px/'

export const allLanguages = ['en', 'uk']
export const maxNameLength = 49 // максимальная длина имени файла (картинки). Если имя длиннее - будем сокращать при отображении
export const tokenLifeTimeInfo= '5 минут' // Время жизни токена (для инфо сообщений)

// Уведомления
export const defNotifyDuration = 14000 // Длительность показа уведомлений по умолчанию (секунд * 1000мс)
export const welcNotifyDuration = 15000 // Длительность показа welcome уведомления (секунд * 1000мс)
export const tokenExpiredMsg = "Срок действия токена истек.<br>Доступ ограничен.<p class='mt-10'>Поделитесь мнением с разработчиком. Напишите свои замечания или советы на <span class='nowrap'><img src='" + define.pathToGraphics + "/mail_16px.png' alt=''/><a href='mailto:web-design@ukr.net' class='mail'>web-design@ukr.net</a></span></p><p class='mt-10'>Хотите продолжить знакомство с приложением? Обновите страницу и снова откройте доступ.</p>"
export const expNotifyDuration = 1641000 // Длительновть показа уведомления "Срок действия токена истек" (секунд * 1000мс)